import React from 'react';
import './Education.css';

const Education = () => {
  return (
    <section className="education-section">
      <div className="education-container">
        <div className="section-header">
          <span className="section-number">[02]</span>
          <h2 className="section-title">
            <span className="glitch" data-text="EDUCATION_LOG">EDUCATION_LOG</span>
          </h2>
        </div>

        <div className="education-layout">
          <div className="edu-main-card">
            <div className="card-corner top-left"></div>
            <div className="card-corner top-right"></div>
            <div className="card-corner bottom-left"></div>
            <div className="card-corner bottom-right"></div>
            
            <div className="edu-header">
              <div className="university-badge">
                <span className="badge-text">UNI</span>
              </div>
              <div className="edu-title">
                <h3 className="university-name">BATMAN_ÜNİVERSİTESİ</h3>
                <p className="department">{'<'}Bilgisayar_Mühendisliği{'/>'}</p>
              </div>
            </div>

            <div className="edu-grid">
              <div className="edu-item">
                <div className="item-label">YEAR_START</div>
                <div className="item-value">2022</div>
              </div>
              <div className="edu-item">
                <div className="item-label">STATUS</div>
                <div className="item-value">4.SINIF</div>
              </div>
              <div className="edu-item">
                <div className="item-label">TYPE</div>
                <div className="item-value">LISANS</div>
              </div>
              <div className="edu-item highlight">
                <div className="item-label">GPA</div>
                <div className="item-value gpa">77.19</div>
                <div className="gpa-bar">
                  <div className="gpa-fill" style={{width: '77.19%'}}></div>
                </div>
              </div>
            </div>
          </div>

          <div className="edu-side-card">
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <div className="timeline-year">2022</div>
                  <div className="timeline-text">Başlangıç</div>
                </div>
              </div>
              <div className="timeline-line"></div>
              <div className="timeline-item">
                <div className="timeline-dot active"></div>
                <div className="timeline-content">
                  <div className="timeline-year">2026</div>
                  <div className="timeline-text">4. Sınıf</div>
                </div>
              </div>
              <div className="timeline-line"></div>
              <div className="timeline-item future">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <div className="timeline-year">202X</div>
                  <div className="timeline-text">Mezuniyet</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
